export default __webpack_public_path__ + "static/media/waves.9b964b3e.png";